import { createReducer } from "reduxsauce";
import Types from "./types";

export const INITIAL_STATE = {
    dealerInfo: null,
    isLoading: false,
    error: null,
    isSSR: false,
    cmsConfig: null,
    cmsLoading: false,
    cmsError: null,
    dealerConfig: null,
    configLoading: false,
    configError: null,
    dealerInventory: {
        results: [],
        total: 0,
        totalPages: null,
        page: 0,
        isLoading: false,
        error: null,
        config: null
    }
};

export const setDealerInfo = (state = INITIAL_STATE, {data}) => {
    return { ...state, dealerInfo: data };
};

export const getDealerInfoStarted = (state = INITIAL_STATE) => {
    return { ...state, isLoading: true, error: null };
};

export const getDealerInfoSuccess = (state = INITIAL_STATE, {data}) => {
    return { ...state, dealerInfo: data, isLoading: false, error: null };
};

export const getDealerInfoFailed = (state = INITIAL_STATE, {error}) => {
    return { ...state, error, isLoading: false };
};

export const updateDealerSSRStatus = (state = INITIAL_STATE, { isSSR }) => {
    return { ...state, isSSR };
};

export const fetchDealerCmsConfigInit = (state = INITIAL_STATE) => {
    return { ...state, cmsLoading: true, cmsError: null };
};

export const fetchDealerCmsConfigSuccess = (state = INITIAL_STATE, {data}) => {
    return { ...state, cmsConfig: data, cmsLoading: false, cmsError: null };
};

export const fetchDealerCmsConfigFailure = (state = INITIAL_STATE, {error}) => {
    return { ...state, cmsError: error, cmsLoading: false };
};

export const getDealerConfigStarted = (state = INITIAL_STATE) => {
    return { ...state, configLoading: true, configError: null };
};

export const getDealerConfigSuccess = (state = INITIAL_STATE, {data}) => {
    return { ...state, dealerConfig: data, configLoading: false, configError: null };
};

export const getDealerConfigFailed = (state = INITIAL_STATE, {error}) => {
    return { ...state, configError: error, configLoading: false };
};

export const fetchDealerInventoryStarted = (state = INITIAL_STATE) => {
    return {
        ...state,
        dealerInventory: {
            ...state.dealerInventory,
            isLoading: true,
            error: null
        }
    };
};

export const fetchDealerInventorySuccess = (state = INITIAL_STATE, {data, params}) => {
    const isFirstPage = params?.page === 0 || !params?.page;
    const currentResults = state.dealerInventory.results || [];
    const newResults = data.results || [];

    return {
        ...state,
        dealerInventory: {
            results: isFirstPage ? newResults : [...currentResults, ...newResults],
            total: data.total || 0,
            totalPages: data.totalPages || null,
            config: data.config || null,
            page: params?.page || 0,
            isLoading: false,
            error: null
        }
    };
};

export const fetchDealerInventoryFailed = (state = INITIAL_STATE, {error}) => {
    return {
        ...state,
        dealerInventory: {
            ...state.dealerInventory,
            error,
            isLoading: false
        }
    };
};

export const resetDealerInventory = (state = INITIAL_STATE) => {
    return {
        ...state,
        dealerInventory: {
            results: [],
            total: 0,
            totalPages: null,
            page: 0,
            isLoading: false,
            error: null,
            config: null
        }
    };
};

export const HANDLERS = {
    [Types.SET_DEALER_INFO]: setDealerInfo,
    [Types.GET_DEALER_INFO_STARTED]: getDealerInfoStarted,
    [Types.GET_DEALER_INFO_SUCCESS]: getDealerInfoSuccess,
    [Types.GET_DEALER_INFO_FAILED]: getDealerInfoFailed,
    [Types.UPDATE_DEALER_SSR_STATUS]: updateDealerSSRStatus,
    [Types.FETCH_DEALER_CMS_CONFIG]: fetchDealerCmsConfigInit,
    [Types.FETCH_DEALER_CMS_CONFIG_SUCCESS]: fetchDealerCmsConfigSuccess,
    [Types.FETCH_DEALER_CMS_CONFIG_FAILURE]: fetchDealerCmsConfigFailure,
    [Types.GET_DEALER_CONFIG_STARTED]: getDealerConfigStarted,
    [Types.GET_DEALER_CONFIG_SUCCESS]: getDealerConfigSuccess,
    [Types.GET_DEALER_CONFIG_FAILED]: getDealerConfigFailed,
    [Types.FETCH_DEALER_INVENTORY_STARTED]: fetchDealerInventoryStarted,
    [Types.FETCH_DEALER_INVENTORY_SUCCESS]: fetchDealerInventorySuccess,
    [Types.FETCH_DEALER_INVENTORY_FAILED]: fetchDealerInventoryFailed,
    [Types.RESET_DEALER_INVENTORY]: resetDealerInventory
};

export default createReducer(INITIAL_STATE, HANDLERS);
